import { useContext, useState, useEffect } from 'react';
import { Container, Typography, Stack } from "@mui/material";
import EventContext from "../store/event-context";
import { Auth } from 'aws-amplify';

const ShowEventDataOnHome = ({version}) => {
    const eventctx = useContext(EventContext);
    const orientationPortrait = (window.innerWidth < window.innerHeight);
    console.log("Width: ", window.innerWidth, " Height: ", window.innerHeight, "-> Portrait?: ", orientationPortrait );
    const marginVersion = window.innerHeight * 0.018;   // Depends on the screen height how much we puch Version to the bottom.
    const pictureSize = (window.innerHeight < 450)? 100: (window.innerHeight < 600)? 120: 180;
    const pictureMargin = (window.innerHeight < 450)? 14: 30;

    const [userName, setUserName] = useState("");
    useEffect(() => {
        const fetchUserName = async () => {
            const data = await Auth.currentUserInfo();
            setUserName(data.username);
          }
        fetchUserName();
    }, [])

    return (
        <Container id="HomeContainer" disableGutters 
                sx={{ width: orientationPortrait? '95%': '40%', 
                      marginBottom: (window.innerHeight < 450)? '4px': '10px' }}>
            <div style={{marginTop:pictureMargin, marginBottom:pictureMargin}}>
                <img  src="./stfc-logo-200.png" alt="Swim to Fight Cancer logo" width={pictureSize} height={pictureSize} />
            </div>
            {eventctx.event && <Stack>
                <Typography sx={{textAlign: 'center', fontWeight: '600', fontSize: '17px'}}>{eventctx.event.name}</Typography>
                <Typography sx={{textAlign: 'center', marginTop: '6px'}}>{`${eventctx.event.location}, ${eventctx.event.date}`}</Typography>
                <Typography sx={{textAlign: 'center', marginTop: '6px'}}>{eventctx.event.email}</Typography>
                {userName &&<Typography  sx={{textAlign: 'center', marginTop: '30px'}}>Welcome: {userName}</Typography>}
                <Typography sx={{textAlign: 'center', marginTop: marginVersion, color: 'lightgray', fontSize:12 }}>Version: {version}</Typography>
            </Stack>}
            <footer id="footer">
                <div id="footer-content" style={{fontSize:12}}>Developed by: 
                    <div><img src="./Cgi-logo-small.png" width="40" height="25" alt="CGI logo"/></div>
                </div>
            </footer>
        </Container>        
    )
}

export default ShowEventDataOnHome
